import { API_ENDPOINT } from "../config";
import { storage as localStorage } from "../utils/storage";

export const addUtilizationEntryApi = async (
  uid: string,
  amount: number,
  description?: string
): Promise<void> => {
  const apiUrl =
    "https://us-central1-discvry.cloudfunctions.net/addUtilizationEntry";

  try {
    // Make the API call to the Firebase function
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.get("accessToken")}`,
      },
      body: JSON.stringify({
        uid,
        amount,
        description,
      }),
    });

    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }

    await response.json();
  } catch (error) {
    console.error("Error calling addUtilizationEntryApi:", error);
    throw new Error("Failed to add utilization entry.");
  }
};

export const remainingCreditsApi = async (uid: string): Promise<number> => {
  const apiUrl = `${API_ENDPOINT.remainingCreditsUrl}?uid=${encodeURIComponent(
    uid
  )}`;

  try {
    // Make the API call to the Firebase function
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.get("accessToken")}`, // Include the access token if required
      },
    });

    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }

    const data = await response.json();

    // Return the remaining credits from the response data
    return data.remainingCredits || 0;
  } catch (error) {
    console.error("Error calling remainingCredits:", error);
    throw new Error("Failed to fetch remaining credits.");
  }
};
